/** One line each: the figure and why it is worth finding. Keyed by IAU abbreviation. */
export const CONSTELLATION_STORIES: Record<string, string> = {
    And: 'The chained princess, offered to a sea monster and rescued by Perseus. She carries our nearest large galaxy in her robe.',
    Ant: 'An air pump, named in the 1750s by Lacaille to honour the new science of vacuums.',
    Aps: 'The bird of paradise, a southern bird that early sailors believed had no feet.',
    Aqr: 'The water bearer, pouring a stream of faint stars toward the mouth of the southern fish.',
    Aql: 'The eagle that carried the thunderbolts of Zeus. Altair, its brightest star, spins once every nine hours.',
    Ara: 'The altar on which the gods swore their oath before the war against the Titans.',
    Ari: 'The ram with the golden fleece, which Jason sailed to the edge of the world to find.',
    Aur: 'The charioteer, cradling a goat and her kids. Capella, the goat star, is really four suns.',
    Boo: 'The herdsman driving the Great Bear round the pole, led by orange Arcturus.',
    Cae: 'The engraver’s chisel, one of the faintest figures in the sky.',
    Cam: 'The giraffe, a long neck of faint stars stretching between the pole and Perseus.',
    Cnc: 'The crab Hera sent to nip at Heracles. It hides the Beehive cluster in its shell.',
    CVn: 'The hunting dogs of Boötes, home to the Whirlpool Galaxy.',
    CMa: 'Orion’s greater dog, wearing Sirius, the brightest star of the night, on its collar.',
    CMi: 'The lesser dog, little more than Procyon, whose name means “before the dog”.',
    Cap: 'The sea goat, half beast and half fish, one of the oldest figures in the sky.',
    Car: 'The keel of the great ship Argo, sailing below the horizon as seen from England.',
    Cas: 'The vain queen, chained to her throne and turned upside down for half of every night.',
    Cen: 'The wise centaur Chiron. Its foot holds Alpha Centauri, the nearest star system to the Sun.',
    Cep: 'The king, Cassiopeia’s husband, a faint house-shaped figure near the pole.',
    Cet: 'The sea monster sent for Andromeda, carrying Mira, the wonderful star that comes and goes.',
    Cha: 'A small chameleon of faint stars close to the south celestial pole.',
    Cir: 'A draughtsman’s compass, set beside the pointers of the Southern Cross.',
    Col: 'The dove Noah sent out to look for dry land.',
    Com: 'Queen Berenice’s hair, cut as an offering for her husband’s safe return.',
    CrA: 'The southern crown, a small arc of stars at the feet of the archer.',
    CrB: 'Ariadne’s wedding crown, thrown into the sky by Dionysus.',
    Crv: 'The crow, punished by Apollo for lying and kept forever just out of reach of the cup.',
    Crt: 'The cup of Apollo, which the thirsty crow was never allowed to drink from.',
    Cru: 'The Southern Cross, the smallest constellation, never seen from Britain.',
    Cyg: 'The swan flying down the Milky Way, tail marked by Deneb and beak by Albireo.',
    Del: 'The dolphin that carried the poet Arion safely back to shore.',
    Dor: 'The swordfish, swimming through the Large Magellanic Cloud.',
    Dra: 'The dragon that guarded the golden apples, coiled around the pole.',
    Equ: 'The little horse, the second-smallest constellation of all.',
    Eri: 'The river, winding from Orion’s foot far down into the southern sky.',
    For: 'The chemist’s furnace, a modern figure full of distant galaxies.',
    Gem: 'The twins Castor and Pollux, inseparable even in death.',
    Gru: 'The crane, a long-necked bird low in the southern autumn sky.',
    Her: 'The hero kneeling on the dragon’s head, carrying the great star cluster M13.',
    Hor: 'A pendulum clock, named by Lacaille for the clockmakers of his age.',
    Hya: 'The water snake, the largest constellation, stretching over a quarter of the sky.',
    Hyi: 'The lesser water snake, coiled close to the south pole.',
    Ind: 'The Indian, one of the figures charted by Dutch navigators in the 1590s.',
    Lac: 'The lizard, a zigzag of faint stars between the swan and Andromeda.',
    Leo: 'The lion of Nemea, whose skin no weapon could pierce. Its heart is Regulus.',
    LMi: 'The lion cub, a handful of faint stars above Leo’s mane.',
    Lep: 'The hare, crouching at Orion’s feet and hiding from the hunter’s dogs.',
    Lib: 'The scales, once the claws of the scorpion, weighing day against night.',
    Lup: 'The wolf, held on a spear by the centaur.',
    Lyn: 'The lynx, so faint that you need the eyes of a lynx to see it.',
    Lyr: 'The lyre of Orpheus, holding Vega and, between its lower strings, the Ring Nebula.',
    Men: 'Table Mountain, the faintest constellation in the sky.',
    Mic: 'The microscope, a faint rectangle south of the sea goat.',
    Mon: 'The unicorn, almost invisible to the eye but rich in nebulae along the Milky Way.',
    Mus: 'The fly, a small bright pattern beneath the Southern Cross.',
    Nor: 'The carpenter’s square, lying across the southern Milky Way.',
    Oct: 'The octant, home of the faint southern pole star.',
    Oph: 'The serpent bearer, the healer Asclepius, who learned how to raise the dead.',
    Ori: 'The hunter, with a nebula where stars are being born hanging from his belt.',
    Pav: 'The peacock, a southern bird with one bright blue-white eye.',
    Peg: 'The winged horse, its body a great empty square of autumn stars.',
    Per: 'The hero who beheaded Medusa. Algol, the demon star, winks in her severed head.',
    Phe: 'The bird that rises again from its own ashes.',
    Pic: 'The painter’s easel, holding a young star still building its planets.',
    Psc: 'Two fish tied together by their tails, where the Sun crosses the equator each March.',
    PsA: 'The southern fish, drinking the water of Aquarius, with lonely Fomalhaut for an eye.',
    Pup: 'The stern of the ship Argo, trailing along the southern Milky Way.',
    Pyx: 'The mariner’s compass, set beside the great ship.',
    Ret: 'The reticle: the crosshair in the eyepiece of Lacaille’s telescope.',
    Sge: 'The arrow, perhaps the one Heracles shot at the eagle.',
    Sgr: 'The archer, aiming at the scorpion’s heart and at the centre of our galaxy.',
    Sco: 'The scorpion that killed Orion. The two are never in the sky together.',
    Scl: 'The sculptor’s studio, a window looking straight out of the galaxy.',
    Sct: 'The shield of a Polish king, set against a bright cloud of the Milky Way.',
    Ser: 'The serpent, the only constellation cut in two, held by Ophiuchus.',
    Sex: 'The sextant Hevelius used to measure the stars, lost in a fire in 1679.',
    Tau: 'The bull, charging Orion with the Pleiades on its shoulder and red Aldebaran for an eye.',
    Tel: 'The telescope, one of the instruments Lacaille set among the southern stars.',
    Tri: 'The triangle, which holds a spiral galaxy almost as near as Andromeda.',
    TrA: 'The southern triangle, close to the pointers of the Southern Cross.',
    Tuc: 'The toucan, which carries the Small Magellanic Cloud.',
    UMa: 'The Great Bear, whose seven brightest stars make the Plough.',
    UMi: 'The Little Bear, with Polaris at the tip of its tail.',
    Vel: 'The sails of the ship Argo, crossed by the southern Milky Way.',
    Vir: 'The maiden holding an ear of wheat, Spica, in front of a field of thousands of galaxies.',
    Vol: 'The flying fish, leaping beside the keel of the Argo.',
    Vul: 'The little fox, which holds the Dumbbell Nebula.'
}

/** Proper names for bright stars, keyed by Hipparcos number. */
export const STAR_NAMES: Record<number, string> = {
    677: 'Alpheratz',
    746: 'Caph',
    1067: 'Algenib',
    2081: 'Ankaa',
    3179: 'Schedar',
    3419: 'Diphda',
    4427: 'Navi',
    5447: 'Mirach',
    6686: 'Ruchbah',
    7588: 'Achernar',
    8886: 'Segin',
    8903: 'Sheratan',
    9640: 'Almach',
    9884: 'Hamal',
    10826: 'Mira',
    11767: 'Polaris',
    13847: 'Acamar',
    14135: 'Menkar',
    14576: 'Algol',
    15863: 'Mirfak',
    17702: 'Alcyone',
    18543: 'Zaurak',
    21421: 'Aldebaran',
    23875: 'Cursa',
    24436: 'Rigel',
    24608: 'Capella',
    25336: 'Bellatrix',
    25428: 'Elnath',
    25930: 'Mintaka',
    25985: 'Arneb',
    26311: 'Alnilam',
    26727: 'Alnitak',
    27366: 'Saiph',
    27989: 'Betelgeuse',
    28360: 'Menkalinan',
    30324: 'Mirzam',
    30343: 'Tejat',
    30438: 'Canopus',
    31681: 'Alhena',
    32246: 'Mebsuta',
    32349: 'Sirius',
    33579: 'Adhara',
    34444: 'Wezen',
    35550: 'Wasat',
    35904: 'Aludra',
    36188: 'Gomeisa',
    36850: 'Castor',
    37279: 'Procyon',
    37826: 'Pollux',
    39429: 'Naos',
    41037: 'Avior',
    44066: 'Acubens',
    44816: 'Suhail',
    45238: 'Miaplacidus',
    46390: 'Alphard',
    49669: 'Regulus',
    50335: 'Adhafera',
    50583: 'Algieba',
    53910: 'Merak',
    54061: 'Dubhe',
    54872: 'Zosma',
    54879: 'Chertan',
    57632: 'Denebola',
    58001: 'Phecda',
    59774: 'Megrez',
    59803: 'Gienah',
    60718: 'Acrux',
    60965: 'Algorab',
    61084: 'Gacrux',
    61941: 'Porrima',
    62434: 'Mimosa',
    62956: 'Alioth',
    63125: 'Cor Caroli',
    63608: 'Vindemiatrix',
    65378: 'Mizar',
    65474: 'Spica',
    65477: 'Alcor',
    67301: 'Alkaid',
    67927: 'Muphrid',
    68702: 'Hadar',
    68756: 'Thuban',
    69673: 'Arcturus',
    71683: 'Rigil Kentaurus',
    72105: 'Izar',
    72607: 'Kochab',
    72622: 'Zubenelgenubi',
    74785: 'Zubeneschamali',
    75097: 'Pherkad',
    76267: 'Alphecca',
    77070: 'Unukalhai',
    78401: 'Dschubba',
    78820: 'Acrab',
    80763: 'Antares',
    80816: 'Kornephoros',
    84012: 'Sabik',
    84345: 'Rasalgethi',
    85670: 'Rastaban',
    85927: 'Shaula',
    86032: 'Rasalhague',
    86228: 'Sargas',
    86742: 'Cebalrai',
    87833: 'Eltanin',
    90185: 'Kaus Australis',
    90496: 'Kaus Borealis',
    91262: 'Vega',
    92420: 'Sheliak',
    92855: 'Nunki',
    93194: 'Sulafat',
    93506: 'Ascella',
    95947: 'Albireo',
    97278: 'Tarazed',
    97649: 'Altair',
    98036: 'Alshain',
    100345: 'Dabih',
    100453: 'Sadr',
    100751: 'Peacock',
    101958: 'Sualocin',
    102098: 'Deneb',
    102488: 'Aljanah',
    105199: 'Alderamin',
    106278: 'Sadalsuud',
    106985: 'Nashira',
    107315: 'Enif',
    107556: 'Deneb Algedi',
    109074: 'Sadalmelik',
    109268: 'Alnair',
    112122: 'Tiaki',
    113368: 'Fomalhaut',
    113881: 'Scheat',
    113963: 'Markab'
}
